import { Injectable, Type } from '@angular/core';
import { Observable, of } from 'rxjs';
import { Version } from '../model/version';
import { version } from 'src/version';

export abstract class VersionService {
    abstract getLatestApplicationVersion(): Observable<Version>;
}

@Injectable()
export class HttpVersionService extends VersionService {
    constructor() {
        super();
    }

    getLatestApplicationVersion(): Observable<Version> {
        // let url = `${environment.infoServerUrl}/api/biopassport/version/${this.getPlatformName()}`;
        // return this.http.get<Version>(url).pipe(map((response) => this.toVersion(response)));
        return of(this.toVersion(version));
    }

    private toVersion(response: any) {
        let version = new Version();
        version.major = response.major;
        version.minor = response.minor;
        version.patch = response.patch;
        version.revision = response.revision;
        return version;
    }
}

@Injectable()
export class StubVersionService extends VersionService {
    getLatestApplicationVersion(): Observable<Version> {
        return of(Version.parse(version));
    }
}

export class VersionServiceFactory {
    static resolve(): Type<any> {
        return StubVersionService;
    }
}
